import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <>
      <Helmet>
        <title>Adgang nægtet (403) - Brønshøj Ure & Guld</title>
      </Helmet>

      <section className="pt-36 sm:pt-40 lg:pt-56 pb-20 lg:pb-28 bg-[#FAF8F5] text-center px-4">
        <div className="max-w-xl mx-auto space-y-6">
          <div className="w-16 h-16 bg-[#F3ECDA] border border-[#CBAA65]/40 text-[#B89343] rounded-full flex items-center justify-center text-2xl mx-auto">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>

          <h1 className="font-serif text-5xl font-bold text-[#1A1714]">403</h1>
          <h2 className="font-serif text-2xl font-bold text-[#8A671F]">Adgang begrænset</h2>

          <p className="text-sm text-gray-600 leading-relaxed">
            Du har ikke adgang til denne side. Klik herunder for at vende tilbage til forsiden.
          </p>

          <div className="pt-4 flex justify-center">
            <Link
              to="/"
              className="px-6 py-3 bg-[#1A1714] text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-[#B89343] transition-colors"
            >
              Gå til forside
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
